import { SurveyTypeEnum } from "enums/administration-screens";

export const DEFAULT_SURVEY_TYPE = SurveyTypeEnum.TEXT_IMAGES;
